import React from "react";
import { Dropdown } from "react-bootstrap";
import allDocuments from "../../Layout/Workdoc/typedoc";
export default class ProductDocumentDropdown extends React.Component {
  onDocumentClick = (document) => {
    this.props.context.redirect(document.url);
  };
  render() {
    const isAccessible = (essence) => {
      let access = this.props.context.user.classAccess[essence] || {};
      if (access.c || access.u || access.d) {
        return true;
      }
      return false;
    };

    let documents = [];
    allDocuments.forEach((doc) => {
      if (doc.inProduct) {
        if (isAccessible(doc.key)) {
          documents.push(doc);
        }
      }
    });

    return (
      <>
        {documents.length > 0 && (
          <Dropdown>
            <Dropdown.Toggle
              className="mr-2"
              variant="light"
              id="dropdownProductDocuments"
              onMouseDown={(e) => {
                e.preventDefault();
              }}
            >
              <i className="flaticon2-add-1"></i>
              <i
                className="fa fa-angle-down ml-1"
                style={{ marginRight: "-10px" }}
              ></i>
              <Dropdown.Menu>
                {documents.map((item) => {
                  return (
                    <Dropdown.Item
                      key={item.key}
                      onClick={() => this.onDocumentClick(item)}
                    >
                      <span
                        className={`svg-icon mr-2 svg-icon-${item.iconColor}`}
                      >
                        {item.icon}
                      </span>{" "}
                      {item.label}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown.Toggle>
          </Dropdown>
        )}
      </>
    );
  }
}
